import { FC } from 'react';
import { AuthenticationClientType } from '../../models/clientModel';
import { useCreateEnvironmentAutomationClientMutation } from '../../services/clients';
import CreateClientForm from './components/CreateClientForm';
import ClientCreatedModal from './components/ClientCreatedModal';

interface Props {
	openModal: boolean;
	setOpenModal: (a: boolean) => void;
}

const CreateCMAutomationClient: FC<Props> = ({ openModal, setOpenModal }) => {
	const {
		data,
		mutate: createClient,
		isLoading,
	} = useCreateEnvironmentAutomationClientMutation();

	const clientData = data?.data as any;
	const handleCreateClient = (values: any) => {
		createClient({
			client: {
				name: values.label,
				description: values.description,
				projectId: values.project,
				environmentId: values.environment,
			},
		});
	};

	return (
		<>
			{!data && (
				<CreateClientForm
					{...{
						openModal,
						setOpenModal,
						onSubmit: handleCreateClient,
						isLoading,
						clientType: AuthenticationClientType.AutomationClient,
					}}
				/>
			)}
			{!!data && (
				<ClientCreatedModal
					{...{
						openModal,
						setOpenModal,
						clientType: AuthenticationClientType.AutomationClient,
						client: clientData,
					}}
				/>
			)}
		</>
	);
};

export default CreateCMAutomationClient;
